import { Link } from "react-router-dom";
import { Coins, Sparkles } from "lucide-react";

/**
 * Subtle floating chip that invites viewers to earn NextScene Coins by
 * referring friends. Dark-luxury look with a soft gold accent.
 *
 * - Authenticated users → routes to /app/rewards
 * - Anonymous viewers    → routes to /signup (they'll get a code post-signup)
 *
 * Positioned as a floating pill; parent controls where it sits.
 */
export default function ReferralChip({ isAuthed, className = "" }) {
  const to = isAuthed ? "/app/rewards" : "/signup";
  return (
    <Link
      to={to}
      data-testid="referral-chip"
      className={`group inline-flex items-center gap-2 rounded-full pl-2.5 pr-3.5 h-9 border border-[#F5C462]/40 bg-black/70 backdrop-blur-md hover:border-[#F5C462] hover:bg-[#F5C462]/10 text-[#F5C462] text-xs font-semibold shadow-lg shadow-black/40 transition-all active:scale-95 ${className}`}
    >
      <span className="w-6 h-6 rounded-full bg-gradient-to-br from-[#F5C462] to-[#B8860B] flex items-center justify-center text-black">
        <Coins size={13}/>
      </span>
      <span className="whitespace-nowrap">Invite &amp; earn coins</span>
      <Sparkles size={11} className="opacity-70 group-hover:opacity-100"/>
    </Link>
  );
}
